import { makeAutoObservable } from "mobx"

export default class CampaignFolder {

  constructor(campaignFolder={}) {
    this.id = campaignFolder.id
    this.name = campaignFolder.name

    makeAutoObservable(this)
  }
}
